export default "__VITE_ASSET__7JERBrkOwiC0E14WMNtXXg__"